import {PlayerColor} from '@colonist/game-states'

export const getColorFromPlayerColor = (playerColor: PlayerColor): string => {
    const COLOR_MAP: Record<PlayerColor, string> = {
        [PlayerColor.None]: '#00000000', // None default to transparent
        [PlayerColor.Red]: '#CF4449',
        [PlayerColor.Blue]: '#285FBD',
        [PlayerColor.Orange]: '#D67236',
        [PlayerColor.Green]: '#338F1D',
        [PlayerColor.Black]: '#3D3D3D',
        [PlayerColor.Bronze]: '#804640',
        [PlayerColor.Silver]: '#878787',
        [PlayerColor.Gold]: '#C79A3E',
        [PlayerColor.White]: '#D3D3D3',
        [PlayerColor.Purple]: '#72559E',
        [PlayerColor.MysticBlue]: '#4FA8C4',
        [PlayerColor.Pink]: '#D66B87',
    }

    return COLOR_MAP[playerColor]
}
